// src/components/FinalCTA/index.js
// Closing full-width call to action before the footer. Personalizes with
// the tenant's real name; CTA uses the same /restaurants route every other
// "Order Now" style button in this app already navigates to.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const FinalCTA = ({ config }) => {
  const navigate = useNavigate();
  const storeName = config?.name || 'us';

  return (
    <section id="final-cta" className="t16-final-cta">
      <div className="t16-final-cta__inner">
        <span className="t16-final-cta__rule" aria-hidden="true" />
        <h2 className="t16-final-cta__title">Ready to Make Your Day a Little Sweeter?</h2>
        <p className="t16-final-cta__desc">Order online from {storeName} and taste the difference.</p>
        <button
          type="button"
          className="t16-final-cta__btn"
          onClick={() => navigate('/restaurants')}
        >
          Shop Now
        </button>
      </div>
    </section>
  );
};

export default FinalCTA;
